import React from "react";
import tradingview from "../../../assets/svgs/tradingview.svg";
export default function AboutUsSixthSection() {
  return (
    <div className="px-10 mt-20 mb-32">
      <p className="text-4xl md:text-6xl mb-16 text-center font-bold text-[#ffffff]">
        Our Partners
      </p>
      <div className="flex justify-center gap-6 flex-wrap lg:flex-nowrap items-center">
        <div className="bg-[#f6f6f6] flex justify-center items-center rounded-xl min-w-full min-h-[200px] w-full  md:min-w-[382px] md:min-h-[200px] md:w-[382px] md:h-[200px]">
          {" "}
          <img src={tradingview} />
        </div>
        <div className="text-base leading-6 font-normal text-[#ffffff]">
          <p>
            Our Technical Charts are provided by TradingView. A comprehensive
            trading and investment platform, offering an exceptional charting
            solution. It empowers traders and investors with cutting-edge
            analytical tools, including
            <a
              className="underline cursor-pointer px-1"
              href="https://www.tradingview.com/markets/cryptocurrencies/global-charts/"
              target="_blank"
            >
              {" "}
              crypto market cap
            </a>
            charts and real-time market data. With its assistance, users can
            conveniently track the price of{" "}
            <a
              className="underline cursor-pointer px-1"
              href="https://www.tradingview.com/symbols/BTCUSD/"
              target="_blank"
            >
              BTC/USD
            </a>{" "}
            price and stay informed about other relevant market trends.
          </p>
        </div>
      </div>
    </div>
  );
}
